import { JSX } from "react";
import { useLocation, useOutlet } from "react-router-dom";

import GroupTransition from "@/components/helpers/GroupTransition/GroupTransition.tsx";

import "./styles.css";

const GateLayout = (): JSX.Element => {
  const { pathname } = useLocation();
  const outlet = useOutlet();

  return (
    <GroupTransition<HTMLDivElement> transitionKey={pathname}>
      {({ ref }) => (
        <div ref={ref} className={"flex min-h-screen flex-col items-center"}>
          {outlet}
        </div>
      )}
    </GroupTransition>
  );
};

export default GateLayout;
